import React from "react";

export default function ColorFrame13({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <path
          d="M84.3861 175.837C84.9037 176.872 114.22 238.481 128.813 269.156"
          stroke="#EE7B76"
          strokeWidth="1.29526"
        />
        <path
          d="M90.6598 175.837C91.1774 176.872 120.493 238.481 135.087 269.156"
          stroke="#EE7B76"
          strokeWidth="1.29526"
        />
        <path
          d="M192.65 175.837C192.132 176.872 162.816 238.481 148.223 269.156"
          stroke="#EE7B76"
          strokeWidth="1.29526"
        />
        <path
          d="M186.592 175.837C186.074 176.872 156.758 238.481 142.165 269.156"
          stroke="#EE7B76"
          strokeWidth="1.29526"
        />
        <path
          d="M238.802 101.451C238.802 157.018 177.105 226.268 138.302 226.268C99.5 226.268 37.8025 157.018 37.8025 101.451C37.8025 45.8833 82.7979 0.836914 138.302 0.836914C193.807 0.836914 238.802 45.8833 238.802 101.451Z"
          fill="#F36F56"
        />
        <rect
          x="112.854"
          y="237.475"
          width="50.897"
          height="38.3621"
          rx="5.18105"
          fill="#FFC444"
        />
        <g style={{ mixBlendMode: "multiply" }} opacity="0.4">
          <rect
            x="118.03"
            y="255.354"
            width="0.521469"
            height="40.1137"
            transform="rotate(-90 118.03 255.354)"
            fill="#FFC444"
          />
          <rect
            x="118.03"
            y="251.71"
            width="0.521469"
            height="40.1137"
            transform="rotate(-90 118.03 251.71)"
            fill="#FFC444"
          />
          <rect
            x="118.03"
            y="269.931"
            width="0.521469"
            height="40.1137"
            transform="rotate(-90 118.03 269.931)"
            fill="#FFC444"
          />
          <rect
            x="118.03"
            y="248.066"
            width="0.521469"
            height="40.1137"
            transform="rotate(-90 118.03 248.066)"
            fill="#FFC444"
          />
          <rect
            x="118.03"
            y="266.287"
            width="0.521469"
            height="40.1137"
            transform="rotate(-90 118.03 266.287)"
            fill="#FFC444"
          />
          <rect
            x="118.03"
            y="244.422"
            width="0.521469"
            height="40.1137"
            transform="rotate(-90 118.03 244.422)"
            fill="#FFC444"
          />
          <rect
            x="118.03"
            y="262.643"
            width="0.521469"
            height="40.1137"
            transform="rotate(-90 118.03 262.643)"
            fill="#FFC444"
          />
          <rect
            x="118.03"
            y="258.998"
            width="0.521469"
            height="40.1137"
            transform="rotate(-90 118.03 258.998)"
            fill="#FFC444"
          />
          <rect
            x="139.65"
            y="241.298"
            width="0.521469"
            height="30.7154"
            fill="#FFC444"
          />
          <rect
            x="121.416"
            y="241.298"
            width="0.521469"
            height="30.7154"
            fill="#FFC444"
          />
          <rect
            x="143.296"
            y="241.298"
            width="0.521469"
            height="30.7154"
            fill="#FFC444"
          />
          <rect
            x="125.063"
            y="241.298"
            width="0.521469"
            height="30.7154"
            fill="#FFC444"
          />
          <rect
            x="146.943"
            y="241.298"
            width="0.521469"
            height="30.7154"
            fill="#FFC444"
          />
          <rect
            x="128.71"
            y="241.298"
            width="0.521469"
            height="30.7154"
            fill="#FFC444"
          />
          <rect
            x="150.59"
            y="241.298"
            width="0.521469"
            height="30.7154"
            fill="#FFC444"
          />
          <rect
            x="132.356"
            y="241.298"
            width="0.521469"
            height="30.7154"
            fill="#FFC444"
          />
          <rect
            x="154.236"
            y="241.298"
            width="0.521469"
            height="30.7154"
            fill="#FFC444"
          />
          <rect
            x="136.003"
            y="241.298"
            width="0.521469"
            height="30.7154"
            fill="#FFC444"
          />
        </g>
        <ellipse
          cx="138.518"
          cy="107.501"
          rx="76.9925"
          ry="76.9397"
          fill="white"
        />
        <path
          d="M157.478 243.62C157.673 246.357 159.827 249.466 153.673 249.466C146.939 249.466 149.143 246.099 149.143 243.359C149.143 240.619 151.16 237.875 153.036 237.875C154.912 237.875 157.269 240.681 157.478 243.62Z"
          fill="#F87E0D"
        />
        <path
          d="M155.414 237.193C155.414 238.491 154.361 239.543 153.062 239.543C151.763 239.543 150.711 238.491 150.711 237.193C150.711 235.895 151.502 236.409 152.801 236.409C154.1 236.409 155.414 235.895 155.414 237.193Z"
          fill="#F87E0D"
        />
        <path
          d="M143.244 243.62C143.439 246.357 145.592 249.466 139.439 249.466C132.704 249.466 134.908 246.099 134.908 243.359C134.908 240.619 136.925 237.875 138.802 237.875C140.678 237.875 143.035 240.681 143.244 243.62Z"
          fill="#F87E0D"
        />
        <path
          d="M141.18 237.193C141.18 238.491 140.127 239.543 138.828 239.543C137.529 239.543 136.476 238.491 136.476 237.193C136.476 235.895 137.268 236.409 138.567 236.409C139.866 236.409 141.18 235.895 141.18 237.193Z"
          fill="#F87E0D"
        />
        <path
          d="M129.023 243.62C129.217 246.357 131.371 249.466 125.218 249.466C118.483 249.466 120.687 246.099 120.687 243.359C120.687 240.619 122.704 237.875 124.58 237.875C126.456 237.875 128.813 240.681 129.023 243.62Z"
          fill="#F87E0D"
        />
        <path
          d="M126.958 237.193C126.958 238.491 125.905 239.543 124.607 239.543C123.308 239.543 122.255 238.491 122.255 237.193C122.255 235.895 123.046 236.409 124.345 236.409C125.644 236.409 126.958 235.895 126.958 237.193Z"
          fill="#F87E0D"
        />
        <path
          d="M114.596 22.4365C115.647 22.1395 116.063 21.6013 115.843 20.822C115.753 20.5048 115.601 20.2786 115.387 20.1435C115.182 20.0057 114.847 19.9291 114.382 19.9135L113.164 19.8614C111.709 19.8028 110.796 19.1165 110.425 17.8025C110.21 17.0413 110.268 16.3494 110.601 15.7269C110.941 15.0928 111.618 14.6324 112.633 14.3456C113.059 14.2252 113.494 14.156 113.939 14.1379C114.382 14.1108 114.868 14.1348 115.398 14.2101L115.291 15.7523C114.807 15.703 114.401 15.6857 114.073 15.7002C113.751 15.7032 113.431 15.7495 113.114 15.8391C112.697 15.9569 112.388 16.1273 112.187 16.3505C111.992 16.5621 111.95 16.8627 112.06 17.2524C112.142 17.5424 112.291 17.7595 112.508 17.9037C112.732 18.0363 113.056 18.111 113.482 18.1277L114.7 18.1798C115.434 18.2169 116.031 18.4056 116.489 18.7458C116.954 19.0744 117.286 19.5922 117.486 20.299C117.716 21.1146 117.645 21.8491 117.272 22.5026C116.896 23.1469 116.155 23.6253 115.05 23.9377C114.615 24.0606 114.148 24.1387 113.648 24.1722C113.155 24.194 112.597 24.1562 111.972 24.0586L112.079 22.5164C112.648 22.5905 113.122 22.623 113.501 22.6137C113.887 22.5929 114.252 22.5338 114.596 22.4365Z"
          fill="white"
        />
        <path
          d="M120.531 18.5349C120.658 19.2105 120.91 19.7379 121.288 20.1171C121.665 20.4871 122.19 20.6085 122.866 20.4814C123.144 20.4291 123.424 20.3381 123.706 20.2084C123.997 20.0769 124.349 19.8814 124.76 19.622L125.545 20.969C125.087 21.2852 124.654 21.5296 124.246 21.7022C123.847 21.8731 123.453 21.9952 123.064 22.0683C122.287 22.2146 121.603 22.1708 121.013 21.9369C120.432 21.7013 119.957 21.3163 119.588 20.7821C119.219 20.2478 118.964 19.6059 118.823 18.8562L118.45 16.8712C118.309 16.1215 118.313 15.4308 118.462 14.799C118.611 14.1673 118.915 13.6406 119.372 13.2192C119.837 12.7868 120.458 12.4974 121.235 12.3511C121.615 12.2797 122.017 12.252 122.441 12.2679C122.864 12.2745 123.336 12.339 123.858 12.4613L123.621 14.0294C123.162 13.9337 122.782 13.8758 122.482 13.8558C122.181 13.8357 121.896 13.8509 121.628 13.9015C120.952 14.0286 120.506 14.3329 120.29 14.8143C120.074 15.2958 120.03 15.8743 120.157 16.5498L120.531 18.5349Z"
          fill="white"
        />
        <path
          d="M132.171 20.7855L131.412 18.9675L128.134 19.2622L127.711 21.1865L126.037 21.337L128.371 11.4832L129.862 11.3491L133.93 20.6274L132.171 20.7855ZM128.785 16.2537L128.473 17.6717L130.781 17.4642L130.22 16.1247L129.299 13.7681L128.785 16.2537Z"
          fill="white"
        />
        <path
          d="M136.005 20.5586L136.203 10.9553L137.757 10.9874C138.481 11.9725 139.166 13.0133 139.812 14.1099C140.458 15.197 141.042 16.3158 141.565 17.4662L141.497 14.5968L141.57 11.0662L143.194 11.0997L142.996 20.7029L141.442 20.6709C140.864 19.4721 140.263 18.2682 139.638 17.0591C139.022 15.8408 138.363 14.6922 137.66 13.6133L137.705 16.9203L137.629 20.5921L136.005 20.5586Z"
          fill="white"
        />
        <path
          d="M151.923 12.0228L153.37 18.9691L157.187 12.9942L159.007 13.33L157.264 22.7758L155.667 22.4811L156.333 18.8694L157.152 15.6018L153.733 20.975L152.246 20.7008L151.028 14.4576L150.624 17.8159L149.958 21.4276L148.36 21.1328L150.103 11.687L151.923 12.0228Z"
          fill="white"
        />
        <path
          d="M165.503 23.567L165.024 25.1192L159.706 23.4781L162.538 14.2999L167.721 15.8993L167.242 17.4515L163.679 16.3519L163 18.552L166.158 19.5266L165.679 21.0788L162.521 20.1042L161.804 22.4257L165.503 23.567Z"
          fill="white"
        />
        {children}
      </g>
    </svg>
  );
}
